// generated from 21 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const tinycluesCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("tinyclues_cohort_filter"),
  comparison_key: z.enum([
    "7", // 20 (95.24%)
    "8", // 1 (4.76%)
  ]),
  display_name: z.string(),
  raw_value: z.string(),
  value: z.object({
    id: z.string(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
